export default __webpack_public_path__ + "b4e49fa05ca6db28459ccc1a0ff9266e.png";